import axios from "axios";

const BACKEND_URL = process.env.REACT_APP_BACKEND_URL;
export const API_BASE = `${BACKEND_URL}/api`;

export const api = axios.create({ baseURL: BACKEND_URL });

// Token injection
api.interceptors.request.use((cfg) => {
  const t = localStorage.getItem("sgpl_token");
  if (t) cfg.headers.Authorization = `Bearer ${t}`;
  return cfg;
});

export const setToken = (t) => {
  if (t) localStorage.setItem("sgpl_token", t);
  else localStorage.removeItem("sgpl_token");
};
export const getToken = () => localStorage.getItem("sgpl_token");
